export const singleDeviceHeaderTypes = {
    FETCH_DEVICE_REQUEST: "SINGLE_DEVICE_HEADER_FETCH_REQUEST",
    FETCH_DEVICE_SUCCESS: "SINGLE_DEVICE_HEADER_FETCH_SUCCESS",
    FETCH_DEVICE_FAILURE: "SINGLE_DEVICE_HEADER_FETCH_FAILURE"
};

export const fetchDeviceRequest = (req) => ({
    type: singleDeviceHeaderTypes.FETCH_DEVICE_REQUEST,
    payload: req
});

export const fetchDeviceSuccess = (resp) => ({
    type: singleDeviceHeaderTypes.FETCH_DEVICE_SUCCESS,
    payload: resp
});

export const fetchDeviceFailure = (error) => ({
    type: singleDeviceHeaderTypes.FETCH_DEVICE_FAILURE,
    payload: error
});